import type { BasketFragmentFragment, BasketQuery } from '@packages/gql/generated/shopping/graphql';
import { LoyaltyFragmentFragmentDoc } from '@packages/gql/generated/shopping/LoyaltyFragmentFragmentDoc';
import { BuyBoxDataFragmentDoc } from '@packages/gql/generated/shopping/BuyBoxDataFragmentDoc';
import { makeFragmentData } from '@packages/gql/generated/shopping';
import { lineItemsMockData } from './lineItems';
import { buyBoxMockDataFull } from './buyBox';
import { loyaltyProgramConnectedMockDataHandler } from './loyaltyProgram';

export const basketMockData: BasketFragmentFragment & BasketQuery['basket'] = {
  success: true,
  itemCount: 5,
  lineItems: lineItemsMockData,
  messages: [],
  loyaltyProgram: {
    ...makeFragmentData(loyaltyProgramConnectedMockDataHandler, LoyaltyFragmentFragmentDoc),
  },
};

export const basketMockDataFragment = {
  success: true,
  lineItems: lineItemsMockData,
  loyaltyProgram: {
    ...makeFragmentData(loyaltyProgramConnectedMockDataHandler, LoyaltyFragmentFragmentDoc),
  },
  ...makeFragmentData(buyBoxMockDataFull, BuyBoxDataFragmentDoc),
  messages: [],
} satisfies BasketFragmentFragment;

export const basketEmptyMockData = {
  success: true,
  lineItems: [],
  messages: [],
  loyaltyProgram: {
    ...makeFragmentData(loyaltyProgramConnectedMockDataHandler, LoyaltyFragmentFragmentDoc),
  },
} satisfies BasketFragmentFragment;
